import styled from 'styled-components';

export const PdfPageWrapper = styled.div({
  pageBreakInside: 'avoid',
});
